import Experience from '../Experience.js'
import * as THREE from 'three'
import  gsap  from "gsap"

import Environment from './Environment.js'
// import Floor from './Floor.js'
// import Fox from './Fox.js'
import Divano from './Divano.js'
import Stanza from './Stanza.js'
import makeDom from '../utils/MakeDom.js'

export default class World
{
    constructor()
    {
        this.experience = new Experience()
        this.baseDir = this.experience.baseDir
        this.time=this.experience.time
        this.scene = this.experience.scene
        this.sceneGroup = this.experience.sceneGroup
        this.camera = this.experience.camera
        this.mouse = this.experience.mouse
        this.sizes = this.experience.sizes
        this.resources = this.experience.resources
        this.sezioni=document.getElementsByClassName('sezioneDivano')
        this.range=Array()
        this.sezioneAttualeN = 0
        this.sezionePrecedenteN = 1
        // this.sezioneAttuale = this.sezioni[0]
        // this.sezionePrecedente = this.sezioni[1]
        this.sources=this.experience.sources
        this.lazySources=this.experience.lazySources
        
        // this.definerange()
        this.environement= new Environment

        // this.allLoaded=this.resources.allLoaded
        

        this.boxColori=document.getElementById('boxColori')
        this.boxModelli=document.getElementById('boxModelli')
        this.boxRoom=document.getElementById('boxRoom')
        this.actualRoom=0
        this.actualModel=0
        this.roomVisible=false
        this.cameraPos=new THREE.Vector2
        // this.stanza={}

        /**
         * Overlay
         */
        const overlayGeometry = new THREE.PlaneGeometry(2, 2, 1, 1)
        this.overlayMaterial = new THREE.ShaderMaterial({
            // wireframe: true,
            transparent: true,
            uniforms:
            {
                uAlpha: { value: 1 }
            },
            vertexShader: `
                void main()
                {
                    gl_Position = vec4(position, 1.0);
                }
            `,
            fragmentShader: `
                uniform float uAlpha;

                void main()
                {
                    gl_FragColor = vec4(1.0,1.0,1.0, uAlpha);
                }
                `
            })
            // gl_FragColor = vec4(0.196,0.227,0.282, uAlpha);
        this.overlay = new THREE.Mesh(overlayGeometry, this.overlayMaterial)
        this.scene.add(this.overlay)
        
        // this.mouse.setTouchControl()


        this.colori=Array
        // for (const elemento of this.sources){
        //     if (elemento.colorName){
        //         this.colori=new makeDom({
        //             tag:'div',
        //             class:['colorButton'],
        //             id:elemento.name,
        //             content:elemento.colorName,
        //             style:'background-image:url(\''+this.baseDir+elemento.path+'\')',
        //             parent:this.boxColori})
        //         if (this.boxColori2){
        //             this.colori=new makeDom({
        //                 tag:'div',
        //                 class:['colorButton2'],
        //                 id:elemento.name,
        //                 content:elemento.colorName,
        //                 style:'background-image:url(\''+this.baseDir+elemento.path+'\')',
        //                 parent:this.boxColori2})    
        //         }
        //     }
        // }
        // this.changeColor1=document.getElementsByClassName('colorButton')
        // if (this.changeColor1) for (const elemento of this.changeColor1){
        //     elemento.onclick = ()=>{
        //         this.divano.changeColor(elemento.id,0)
        //     }
        // }
        // this.changeColor2=document.getElementsByClassName('colorButton2')
        // if (this.changeColor2) for (const elemento of this.changeColor2){
        //     elemento.onclick = ()=>{
        //         this.divano.changeColor(elemento.id,1)
        //     }
        // }

        this.section = 0
        // Wait for resources
        this.resources.on('ready', () =>{this.setModel(this.sources);this.positioncontrol()})
        this.resources.on('readyLazy', () =>{this.setModelLazy(this.lazySources);this.positioncontrol()})
        this.mouse.on('scroll',()=>{this.positioncontrol()})

        
    }
    setColorButton(sources){
        for (const elemento of sources){
            if (elemento.comboName){
                this.colori=new makeDom({
                    tag:'div',
                    class:['colorButton'],
                    id:elemento.name,
                    content:elemento.colorName,
                    style:'background-image:url(\''+this.baseDir+elemento.path+'\')',
                    parent:this.boxColori})
                // if (this.boxColori2){
                //     this.colori=new makeDom({
                //         tag:'div',
                //         class:['colorButton2'],
                //         id:elemento.name,
                //         content:elemento.colorName,
                //         style:'background-image:url(\''+this.baseDir+elemento.path+'\')',
                //         parent:this.boxColori2})    
                // }
            }
        }
        this.changeColor1=document.getElementsByClassName('colorButton')
        if (this.changeColor1) for (const elemento of this.changeColor1){
            elemento.onclick = ()=>{
                for(const divanx of this.divano){
                    // console.log(divanx)
                    divanx.changeColor(elemento.id)
                }
                for (const bottoni of this.changeColor1){
                    bottoni.classList.remove('current')
                }
                elemento.classList.add('current')
                // this.divano[this.actualModel].changeColor(elemento.id,0)
            }
        }
        // this.changeColor2=document.getElementsByClassName('colorButton2')
        // if (this.changeColor2) for (const elemento of this.changeColor2){
        //     elemento.onclick = ()=>{
        //         this.divano.changeColor(elemento.id,1)
        //     }
        // }
        this.showColorOut=false
        this.showColor=document.getElementsByClassName('tavolozza')
        this.openpanel=document.getElementsByClassName('infopannello')
        if (this.showColor) {
            this.openpanel[0].onclick = ()=>{
                if (!this.showColorOut) {
                //     this.showColor[0].classList.add("tshow")
                //     // this.showColor[0].style["margin-right"]= '90%' 
                //     this.showColorOut=false
                // }else{
                    // this.showColor[0].style["margin-right"]= '0'
                    this.showColor[0].classList.add("tshow")
                    this.showColorOut=true
                }

                // console.log(this.showColor[0])
            }
        }
        this.closepanel=document.getElementById('closeinfo')
        // console.log(this.closepanel)
        if (this.closepanel){
            this.closepanel.onclick = ()=>{
                if (this.showColorOut) {
                    // console.log(this.showColor[0])
                    this.showColor[0].classList.remove("tshow")
                    // console.log(this.showColor[0])
                    // this.showColor[0].style["margin-right"]= '90%' 
                    this.showColorOut=false

                }
            }
        }

    }
    setModel(sources){
        // console.log(sources)
        this.divano=[]
        this.divano.push(new Divano('divano',1))
        // this.stanza=[]
        // for(const elem of sources){
        //     if (elem.tipo=='ambiente'){
        //         this.stanza.push(new Stanza(elem.name))
        //         let num=0;
        //         const pippo=new makeDom({
        //             tag:'div',
        //             class:['sceltastanza'],
        //             id:this.stanza.length-1,
        //             content:elem.name,
        //             style:'background-image:url(\''+this.baseDir+elem.imgpath+'\')',
        //             parent:this.boxRoom})
        //         num++   
        //     }
        // }
        gsap.to(this.overlayMaterial.uniforms.uAlpha, { duration: 0.5, value: 0, delay: 1.2, onComplete:()=>{this.scene.remove(this.overlay)} })

        // this.changeRoom=document.getElementsByClassName('sceltastanza')
        // if (this.changeRoom) for (const elemento of this.changeRoom){
        //     elemento.onclick = ()=>{
        //         let vaia=elemento.id
        //         if (vaia!=this.actualRoom && this.roomVisible){
        //             this.stanza[this.actualRoom].hide()
        //             this.stanza[vaia].show(500)
        //             this.actualRoom=vaia
        //         }console.log(this.stanza)
        //     }
        // }
        this.position()
        this.setColorButton(sources)
        
        // if (this.resources.)
    }
    setModelLazy(sources){
        // this.divano = new Divano()
        this.stanza=[]
        if (this.resources.modelb){
            const pipps=new makeDom({
                tag:'div',
                class:['sceltadivano','current'],
                id:this.divano.length-1+'',
                content:this.experience.modelA,
                // style:'background-image:url(\''+this.baseDir+elem.imgpath+'\')',
                parent:this.boxModelli})

        }
        // this.divano=[]
         for(const elem of sources){
            if (elem.tipo=='ambiente'){
                this.stanza.push(new Stanza(elem.name))
                let num=0;
                // console.log(this.stanza.length-1)
                const pippo=new makeDom({
                    tag:'div',
                    class:['sceltastanza'],
                    id:this.stanza.length-1+'',
                    content:elem.name,
                    style:'background-image:url(\''+this.baseDir+elem.imgpath+'\')',
                    parent:this.boxRoom})
                num++   
            }
            if (elem.tipo=='divano'){
                this.divano.push(new Divano(elem.name,0))
                // console.log(this.divano)
                // let num=0;
                // console.log(this.stanza.length-1)
                // console.log(elem.name)
                var nomediv=''
                if (elem.name=='divano-B'){
                    nomediv=this.experience.modelB
                }else{
                    nomediv=this.experience.modelC
                }
                const pipps=new makeDom({
                    tag:'div',
                    class:['sceltadivano'],
                    id:this.divano.length-1+'',
                    content:nomediv,
                    // style:'background-image:url(\''+this.baseDir+elem.imgpath+'\')',
                    parent:this.boxModelli})
                // num++   
            }
            
        }
        // gsap.to(this.overlayMaterial.uniforms.uAlpha, { duration: 3, value: 0, delay: 1, onComplete:()=>{this.scene.remove(this.overlay)} })

        this.changeRoom=document.getElementsByClassName('sceltastanza')
        if (this.changeRoom) for (const elemento of this.changeRoom){
            elemento.onclick = ()=>{
                let vaia=elemento.id
                if (vaia!=this.actualRoom && this.roomVisible){
                    this.stanza[this.actualRoom].hide()
                    this.stanza[vaia].show(500)
                    this.actualRoom=vaia
                }
                // console.log(this.stanza)
            }
        }
        this.changeModel=document.getElementsByClassName('sceltadivano')
        if (this.changeModel) for (const elemento of this.changeModel){
            elemento.onclick = ()=>{
                let vaia=elemento.id
                if (vaia!=this.actualModel){
                    this.divano[this.actualModel].hide()
                    // console.log('actual='+this.actualModel)
                    this.divano[vaia].show(200)
                    this.actualModel=vaia
                }
                for (const bottoni of this.changeModel){
                    bottoni.classList.remove('current')
                }
                elemento.classList.add('current')
                // console.log(this.stanza)
            }
        }
        this.position()
        this.setColorButton(sources)
        
        // if (this.resources.)
    }
    definerange(){
        // window.scrollTo(0,0)
        // window.scrollY
        this.range[0]=0+window.scrollY
        this.range[1]=this.sezioni[1].getBoundingClientRect().top+window.scrollY
        this.range[2]=this.sezioni[2].getBoundingClientRect().top+window.scrollY
        // console.log(this.range)

    }
    
    positioncontrol(){
        if (!this.range[1]){
            window.scrollTo(0,0)
            this.definerange()
        }
        var livY=window.scrollY+this.sizes.vertConst
        if (livY<=this.range[1]){
            this.sezioneAttualeN=0
        }else if (livY<=this.range[2]){
            this.sezioneAttualeN=1
        }else {this.sezioneAttualeN=2}


        // // console.log('pippo')
        // var docViewTop = window.scrollY
        // // alert(window.pageYOffset)
        // var docViewBottom = docViewTop + window.innerHeight
        // // var i=0
        //     Array.from(this.sezioni).forEach((element) => {
        //         //this.range[i]=
        //     // var elemTop = element.getBoundingClientRect().top
        //     // // var elemBottom = elemTop + element.offsetHeight
        //     // // // console.log(elemTop+' - '+elemBottom)
        //     // if ((elemTop >= 0) && (elemTop <= window.innerHeight)){
        //     //     this.sezioneAttuale=element
        //     // }
            
            
        //     var elemTop = window.scrollY+element.getBoundingClientRect().top
        //     var elemBottom = elemTop + element.offsetHeight
        //     // console.log(elemTop+' - '+elemBottom)
        //     if ((elemBottom <= docViewBottom) && (elemTop >= docViewTop)){
        //         this.sezioneAttuale=element
        //     }
            
        // })
        // console.log(this.sezioni[2])

        if (this.sezioneAttualeN!=this.sezionePrecedenteN){
            if (this.sezioneAttualeN== 0){
                this.sezionePrecedenteN=0
                //ANIMAZIONE 1
                // console.log('faccio la base')
                this.camera.posizione1()
                this.mouse.goToPoint(0,1)
                if (this.roomVisible) {
                    this.stanza[this.actualRoom].hide()
                    this.roomVisible=false
                }
                if (this.divano){
                    if (this.divano[this.actualModel].misureVisible){
                    this.divano[this.actualModel].showMeasure(false)
                    }
                }
            }
            if (this.sezioneAttualeN==1){
                this.sezionePrecedenteN=1
                //ANIMAZIONE 1
                // console.log('faccio la prima')
                if (this.roomVisible) {
                    this.stanza[this.actualRoom].hide()
                    this.roomVisible=false
                }
                // this.stanza[this.actualRoom].hide()
                this.mouse.goToPoint(0.5,0.5)
                this.camera.posizione2()
                if (this.divano){
                    if (!this.divano[this.actualModel].misureVisible){
                        this.divano[this.actualModel].showMeasure(true)
                    }
                }
            }
            if (this.sezioneAttualeN==2 && this.resources.allLoaded){
                this.sezionePrecedenteN=2
                //ANIMAZIONE 1
                // console.log(this.stanza)
                this.mouse.goToPoint(-0.5,0.5)
                this.camera.posizione3()
                // this.stanza[this.actualRoom].show()
                if (!this.roomVisible){
                    this.stanza[this.actualRoom].show(200)
                    this.roomVisible=true
                }
                if (this.divano){
                    if (this.divano[this.actualModel].misureVisible){
                        this.divano[this.actualModel].showMeasure(false)
                    }
                }
            }
        }
    }

    update()
    {
        if (this.resources.basicLoaded && (this.mouse.hold || !this.mouse.moveEndY || !this.mouse.moveEndX || this.mouse.touchscreen)){

            this.position()
            // console.log('pippo')
            // console.log(this.camera)
            // this.cameraPos.x=this.mouse.clickStart.x
            // this.cameraPos.x
            // this.sceneGroup.rotation.x=(-Math.sin(this.mouse.smoothy-0.5)/2)+0.15
            // this.sceneGroup.rotation.y=(Math.sin(this.mouse.smoothx)/1.5)



            // this.sceneGroup.quaternion.copy(this.camera.instance.quaternion)
        }
        //     this.divano.model.rotation.y = Math.sin (this.mouse.smoothx) * 2 
        // if (this.stanza)
        //     this.stanza.model.rotation.y = Math.sin (this.mouse.smoothx) * 2 
        // console.log(this.mouse.smoothx)
        // this.camera.instance.position.y=-this.mouse.smoothy*1+0.6
        // this.camera.instance.position.x=-Math.sin(this.mouse.smoothx*Math.PI/3)*2
        // this.camera.instance.position.z=Math.cos(this.mouse.smoothx*Math.PI/3)*1
        // this.camera.update()

        // console.log(this.camera.cameraGroup.position.z)
        // if (this.divano)
        //     this.divano.model.rotation.y = Math.sin (this.time.elapsed * 0.0001) * 1.2 - 0.3 
        // if(this.fox)
        //     this.fox.update()
    }
    position(){
        this.sceneGroup.rotation.x=((-Math.sin(this.mouse.smoothPos.y-0.1)/2)+0.4)
        this.sceneGroup.rotation.y=(Math.sin(this.mouse.smoothPos.x)*1.6)
        this.sceneGroup.updateMatrixWorld(true)
        this.positioncontrol()
        this.divano[this.actualModel].setMisure()
        // console.log('ruoto?')
        // this.sceneGroup.rotation.x=(-Math.sin(this.mouse.positionRel.y-0.5)/2)+0.15
        // this.sceneGroup.rotation.y=(Math.sin(this.mouse.positionRel.x)/1.5)
    }
}